import { alpha } from "@mui/material";

const styles = (theme) => ({
  modalContent: {
    padding: theme.spacing(3),
  },
  modalTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  dropzoneContainer: {
    border: `2px dashed ${alpha(theme.palette.primary.main, 0.5)}`,
    borderRadius: "8px",
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
    minHeight: "200px",
  },
  dropzoneActive: {
    backgroundColor: alpha(theme.palette.primary.main, 0.15),
    borderColor: theme.palette.primary.main,
  },
  cropContainer: {
    position: "relative",
    width: "100%",
    height: "250px",
    backgroundColor: "#333",
    borderRadius: "8px",
    overflow: "hidden",
  },
  zoomSliderContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 2),
  },
  descriptionField: {
    marginTop: theme.spacing(3),
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  selectedFileContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
});

export default styles;
